<template>
  <div>
    <p class="mt-4" ref="title">
      <b>{{ component.label }}</b>
    </p>
    <v-list three-line>
      <v-list-tile v-for="(item, index) in selectedItems" :key="index">
        <v-list-tile-content>
          <v-list-tile-sub-title>{{ item }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="removeItem(item)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider v-if="value.length"></v-divider>
      <v-list-tile v-if="!showEditorPane && limitEntries(selectedItems.length)">
        <v-list-tile-content>
          <v-list-tile-title @click="showPane()"> Adicionar </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="showPane()">
            <v-icon color="primary">add_circle</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <div class="px-3 card-rounded border grey--border" v-if="showEditorPane">
      <IcdInput
        v-model="diagnosis"
        itemValue="code"
        itemText="long_description_pt"
        :excludedCodes="excludedCodes"
        :showFavorites="showFavorites"
      />
      <v-layout wrap class="my-2">
        <template v-if="user.specialty === 'endocrinology'">
          <v-btn
            class="ml-0"
            small
            depressed
            :color="showFavorites ? 'secondary' : ''"
            @click="openFavoritesTable">
            favoritos
          </v-btn>
          <v-btn
          :color="!showFavorites ? 'secondary' : ''"
            class="ml-0" small depressed @click="showFavorites = false">
            <v-icon small class="mr-1">search</v-icon> ICD10
          </v-btn>
        </template>
        <v-spacer />
        <v-btn
          class="ml-0"
          small
          v-if="paneIndex === null"
          color="primary"
          :disabled="!diagnosis"
          @click="addItem()"
          >Adicionar</v-btn
        >
        <v-btn
          class="ml-0"
          small
          color="#fb9db8"
          depressed
          @click.prevent="cancel"
          >Cancelar</v-btn
        >
        <v-btn
          v-if="user.specialty !== 'endocrinology'"
          class="ml-0"
          small
          depressed
          :color="showFavorites ? 'secondary' : ''"
          @click="showFavorites = !showFavorites"
          >Mostrar favoritos
        </v-btn>
      </v-layout>
    </div>

    <IcdFavoriteSelect
      v-model="diagnosis"
      itemValue="code"
      itemText="long_description_pt"
      :logbook="logbook"
      :showFavoritesTable.sync="showFavoritesTable"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import * as algolia from '../../../services/algolia'
import IcdInput from '../../../components/inputs/IcdInput'
import IcdFavoriteSelect from '../../../components/inputs/IcdFavoriteSelect.vue'

export default {
  props: {
    value: { type: Array, default: () => [] },
    component: { type: Object },
    mainIcd10: { type: Boolean, default: false },
    logbook: { type: String }
  },
  components: {
    IcdInput,
    IcdFavoriteSelect
  },
  data() {
    return {
      showFavorites: false,
      loading: false,
      item: null,
      selection: null,
      items: [],
      search: null,
      selectedItems: [],
      paneIndex: null,
      showEditorPane: false,
      diagnosis: null,
      showFavoritesTable: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    excludedCodes() {
      return this.selectedItems.map(item => {
        const [code] = item.split(':')
        return code
      })
    }
  },
  watch: {
    search(newval) {
      if (newval && newval !== this.value) {
        this.items = []
        this.querySelections(newval)
      }
    }
  },
  created() {
    if (this.value) {
      this.selectedItems = this.value
    }
  },

  methods: {
    async querySelections(query = '') {
      this.loading = true
      const data = await algolia.search(query)

      this.items = data.map(entry => ({
        code: entry.code,
        long_description: entry.long_description_pt
      }))
      this.loading = false
    },
    showPane(item = null, index = null) {
      if (item) {
        this.paneIndex = index
        this.diagnosis = item
      } else {
        this.paneIndex = null
      }
      this.showEditorPane = true
    },
    selectItem(target) {
      if (!target) {
        this.item = {}
        return
      }
      this.item = this.items.find(
        ({ long_description }) => long_description == target
      )
    },
    emitUpdate(newItems) {
      this.$emit('input', newItems)
    },

    removeItem(item) {
      if (this.paneIndex !== null) {
        this.paneIndex = null
        this.showEditorPane = false
      }
      this.selectedItems = this.selectedItems.filter(element => element != item)

      this.emitUpdate(this.selectedItens)
    },
    addItem() {
      if (this.diagnosis) {
        this.selectedItems.push(this.diagnosis)
        this.emitUpdate(this.selectedItems)

        this.showEditorPane = false
        this.diagnosis = ''
      }
    },
    editItem() {
      if (this.diagnosis) {
        this.selectedItems.splice(this.paneIndex, 1, this.diagnosis)
        this.emitUpdate(this.selectedItems)

        this.showEditorPane = false
        this.diagnosis = ''
      }
    },
    cancel() {
      this.showEditorPane = false
      this.showFavorites = false
      this.paneIndex = null
      this.diagnosis = ''
    },
    limitEntries(value) {
      if (this.mainIcd10 && value < 4) {
        return true
      } else if (!this.mainIcd10 && value < 8) {
        return true
      } else {
        return false
      }
    },
    openFavoritesTable() {
      this.showFavoritesTable = true
      this.showFavorites = true
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
